<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="elevation-0"
                    rounded
                    :loading="submitting"
                    :disabled="submitting || loading"
                    v-bind="attrs"
                    v-on="on"
                    block
                >
                    Afmelden
                </v-btn>
            </template>
            <v-card>
                <v-card-title class="text-h5">
                    Afmelden bij POrtaal
                </v-card-title>
                <v-card-text class="my-4">
                    Weet je zeker dat je dit account wilt verwijderen van POrtaal?<br>
                    Na het verwijderen heb je geen toegang meer tot dit account.
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="secondary"
                        @click="dialog = false"
                        text
                    >
                        Terug
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="submit"
                    >
                        Ja, afmelden
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    data () {
        return {
            dialog: false,
        }
    },
    props: {
        submitting: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        submit () {
            this.dialog = false;
            this.$emit('deactivateAccount')
        }
    }
}
</script>
